'use client';

import * as React from 'react';

import {
    Sidebar,
    SidebarContent,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
} from '@/components/ui/sidebar';
import { ROUTES } from '@/constants/routes';
import { useAppContext } from '@/context/app-context';
import { useActivePath } from '@/components/layouts/use-active-path';

const HOME_PAGE_SECTIONS = [
    { name: 'Home', path: ROUTES.Home },
    { name: 'Hyper Report', path: ROUTES.HyperReport },
];

export default function HomeSidebar() {
    const { goToPage } = useAppContext();

    const { activePath, setActivePath } = useActivePath();

    const handleClick = (path: string) => {
        setActivePath(path);
        goToPage(path);
    };

    return (
        <Sidebar className="border-r border-neutral-650">
            <SidebarContent className="overflow-y-auto scrollbar-thin scrollbar-thumb-gray-600 scrollbar-track-transparent hover:scrollbar-thumb-gray-500 pr-1 scrollbar-thumb-rounded-md p-4">
                <SidebarMenu>
                    {HOME_PAGE_SECTIONS.map((item) => (
                        <SidebarMenuItem key={item.name}>
                            <SidebarMenuButton
                                isActive={item.path === activePath}
                                label={item.name}
                                onClick={() => handleClick(item.path)}
                            />
                        </SidebarMenuItem>
                    ))}
                </SidebarMenu>
            </SidebarContent>
        </Sidebar>
    );
}
